module.exports = __webpack_public_path__ + "img/logo-small.ca96e92.svg";